var React = require('react');

function HandMiddleFinger (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M479.93,317.16,480,400A112,112,0,0,1,368.05,512h-215a112,112,0,0,1-79.19-32.81L42.93,448.28A37.31,37.31,0,0,1,32,421.89V348.44A37.34,37.34,0,0,1,52.64,315L80,300v76a8,8,0,0,0,16,0V229c0-15.26,12.87-28.38,30.87-31.38l30.68-5.12c17.82-3,34.45,8.39,34.45,23.54v32a8,8,0,0,0,16,0V46.54A48,48,0,0,1,257.44,0h0C283.75.86,304,23.78,304,50V248a8,8,0,0,0,16,0V216c0-15.14,16.63-26.49,34.45-23.53l38.4,6.4C406.31,201.16,416,211,416,222.45V272l35.65,9A37.34,37.34,0,0,1,479.93,317.16Z","className":"fa-primary","key":1})]);
}

HandMiddleFinger.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = HandMiddleFinger;

HandMiddleFinger.default = HandMiddleFinger;
